<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Awards & Recognition</h1>
    <p class="lead mb-0 text-orange-light">Celebrating Institutional Achievements</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <h3 class="fw-bold text-success mb-4 text-uppercase border-bottom pb-2">
    <i class="fa-solid fa-certificate me-2"></i> UGC Recognitions
  </h3>
  
  <div class="mb-5 d-flex flex-wrap gap-3">
    <a href="assets/pdf/Section 2(f) Recognition Letter.pdf" target="_blank" class="text-decoration-none d-inline-flex align-items-center p-3 bg-light rounded shadow-sm border hover-shadow transition-all">
      <div class="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3" style="width: 45px; height: 45px;">
        <i class="fa-solid fa-file-pdf fs-5"></i>
      </div>
      <div>
        <h6 class="mb-1 text-dark fw-bold">Recognition of College under Section 2(f) of the UGC Act, 1956</h6>
        <small class="text-muted"><i class="fa-solid fa-download me-1"></i> Download / View PDF</small>
      </div>
    </a>
    
    <a href="assets/pdf/365_C-22432_SHAH_SATNAM_JI_GIRLS_COLLEGE_SIRSA (1).pdf" target="_blank" class="text-decoration-none d-inline-flex align-items-center p-3 bg-light rounded shadow-sm border hover-shadow transition-all">
      <div class="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3" style="width: 45px; height: 45px;">
        <i class="fa-solid fa-file-pdf fs-5"></i>
      </div>
      <div>
        <h6 class="mb-1 text-dark fw-bold">Certificate of Recognition – AISHE 2024–25</h6>
        <small class="text-muted"><i class="fa-solid fa-download me-1"></i> Download / View PDF</small>
      </div>
    </a>
  </div>

  <h3 class="fw-bold text-success mb-4 text-uppercase border-bottom pb-2">
    <i class="fa-solid fa-award me-2"></i> Awards Photo Gallery
  </h3>

  <div class="row g-4">
    <div class="col-12 col-md-6 col-lg-3" *ngFor="let item of awards">
      <div class="award-card h-100 shadow-sm border-0 rounded-4 overflow-hidden bg-white">
        <div class="award-img-box position-relative">
          <img [src]="item.img" [alt]="item.title" class="award-img img-fluid">
          <div class="img-badge bg-orange text-white fw-bold px-2.5 py-1 rounded small">Award</div>
        </div>
      </div>
    </div>
  </div>
</div>
